import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Spin } from "antd";
import { observer } from "mobx-react";
import { OptionsPostTypesTable } from "./postTypesTable.js";
import { useStores } from "../../store/rootStore.js";
import { __ } from "../../utils/i18n.js";
import { ConfigLicensing } from "../licensing/licensing.js";
const OptionsPage = observer(()=>{
    const { optionStore: { busySettings, others: { showLicenseFormImmediate } } } = useStores();
    return showLicenseFormImmediate ? /*#__PURE__*/ _jsx(ConfigLicensing, {}) : /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: "wp-heading-inline",
                style: {
                    marginBottom: 10
                },
                children: __("Category Management")
            }),
            /*#__PURE__*/ _jsxs(Spin, {
                spinning: busySettings,
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "description",
                        style: {
                            marginBottom: 15
                        },
                        children: __("You can decide for which post types the additional features of Real Category Management should apply.")
                    }),
                    /*#__PURE__*/ _jsx(OptionsPostTypesTable, {})
                ]
            })
        ]
    });
});
export { OptionsPage };
